import React, { useEffect } from 'react';
import MetaTags from './MetaTags';

interface BulletinMetaTagsProps {
  bulletin: {
    id: string;
    content?: string;
    profiles?: {
      username?: string;
    };
    image_url?: string;
  };
}

/**
 * Component to generate meta tags specifically for bulletin content sharing
 */
const BulletinMetaTags: React.FC<BulletinMetaTagsProps> = ({ bulletin }) => {
  const bulletinUrl = `${window.location.origin}/bulletins?id=${bulletin.id}`;
  
  // Generate bulletin-specific title
  const title = bulletin.profiles?.username 
    ? `${bulletin.profiles.username} on FOMO` 
    : "FOMO – Community‑Powered Social Platform";
  
  // Generate bulletin-specific description
  // Trim content to ~150 chars for social media previews
  const description = bulletin.content
    ? `${bulletin.content.slice(0, 150)}${bulletin.content.length > 150 ? '...' : ''}`
    : "Join a vibrant community, share moments that matter, and earn from your creativity";
  
  // Use bulletin image if available, otherwise default (must be absolute URL for social sharing)
  const image = bulletin.image_url 
    ? bulletin.image_url 
    : "https://guwcqpytunuquoirejsc.supabase.co/storage/v1/object/public/fomo-assets/fomo_metatags2.png";

  return (
    <MetaTags
      title={title}
      description={description}
      image={image}
      url={bulletinUrl}
    />
  );
};

export default BulletinMetaTags;
